export default `
  mutation adminSetPlatformRole($email: String!, $group: String!, $grant: Boolean!) {
    adminSetPlatformRole(email: $email, group: $group, grant: $grant) {
      email
      group
      granted
    }
  }
`
